/* Project Import will be here */
import { post, IRequest } from "./index";
import { IGenerateComplaintModel } from "models/complaintModels";
/* Project Import will be here */

/* Get my complaint list API */
export const getMyComplaintsListApi = () => {
    const request: IRequest = {
        subUrl: `/Product/Complaints`
    };

    return post(request);
};

/* Get generate complaints meta data like Complaint Type, Complaint Reason, Method Of Disposal and etc... */
export const getGenerateComplaintsMetaDataApi = () => {
    const request: IRequest = {
        subUrl: `/Appconfig/ComplaintLovs`
    };

    return post(request);
};

/* Generate new complaint */
export const generateNewComplaintApi = (data: IGenerateComplaintModel) => {
    const request: IRequest = {
        subUrl: `/Product/AddComplaint`,
        data
    };

    return post(request);
};